import {ProductApi, SubstanceApi} from "@core/api";

export default {
    data() {
        return {
            additionalMaterials: [],
            mixtureCategories: [],
            materialCategories: [],
        };
    },
    methods: {
        initSubstanceDictionaries() {
            ProductApi.additionalMaterials().then(r => this.additionalMaterials = r.data);
            ProductApi.mixtureCategories().then(r => {
                r.data.forEach(this.disableUnselectablecategories);
                this.mixtureCategories = r.data;
            });
            SubstanceApi.materialCategories().then(r => {
                r.data.forEach(this.disableUnselectablecategories);
                this.materialCategories = r.data
            });
        },

        disableUnselectablecategories(node) {
            //  think through how to disable node
            node.isDisabled = !node.selectable;

            if (node.children) {
                node.children.forEach(this.disableUnselectablecategories);
            }
        },
    }
};
